import { z } from 'zod';

/** Contratos de Relatórios (M6). Reusa as agregações do dashboard no back. */

export const reportMetricSchema = z.enum(['expense', 'income']);
export type ReportMetric = z.infer<typeof reportMetricSchema>;

export const reportDimensionSchema = z.enum(['category', 'account']);
export type ReportDimension = z.infer<typeof reportDimensionSchema>;

const ymSchema = z.string().regex(/^\d{4}-\d{2}$/);

/** Nó de composição (rosca): pai com % e filhos aninhados. */
export interface ReportSlice {
  id: string;
  name: string;
  color: string;
  icon: string | null;
  totalCents: number;
  percent: number;
  children: Array<{
    id: string;
    name: string;
    color: string;
    icon: string | null;
    totalCents: number;
    percent: number;
  }>;
}
export const reportSliceSchema: z.ZodType<ReportSlice> = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string(),
  icon: z.string().nullable(),
  totalCents: z.number().int(),
  percent: z.number(),
  children: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      color: z.string(),
      icon: z.string().nullable(),
      totalCents: z.number().int(),
      percent: z.number(),
    }),
  ),
});

export const reportQuerySchema = z.object({
  month: ymSchema.optional(),
  metric: reportMetricSchema.default('expense'),
  dimension: reportDimensionSchema.default('category'),
  tagId: z.string().min(1).optional(),
});
export type ReportQuery = z.infer<typeof reportQuerySchema>;

export const reportResponseSchema = z.object({
  month: ymSchema,
  metric: reportMetricSchema,
  dimension: reportDimensionSchema,
  totalCents: z.number().int(),
  slices: z.array(reportSliceSchema),
});
export type ReportResponse = z.infer<typeof reportResponseSchema>;

/** Série mensal para os relatórios de evolução (linha/barras). */
export const reportEvolutionQuerySchema = z.object({
  end: ymSchema.optional(),
  months: z.coerce.number().int().min(3).max(24).default(12),
  metric: reportMetricSchema.default('expense'),
  tagId: z.string().min(1).optional(),
});
export type ReportEvolutionQuery = z.infer<typeof reportEvolutionQuerySchema>;

export const reportEvolutionResponseSchema = z.object({
  points: z.array(
    z.object({
      month: ymSchema,
      incomeCents: z.number().int(),
      expenseCents: z.number().int(),
      balanceCents: z.number().int(),
    }),
  ),
});
export type ReportEvolutionResponse = z.infer<typeof reportEvolutionResponseSchema>;

/** Saldos por conta (5º tipo do dropdown). */
export const reportBalancesResponseSchema = z.object({
  month: ymSchema,
  accounts: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      color: z.string(),
      icon: z.string().nullable(),
      currentCents: z.number().int(),
      predictedCents: z.number().int(),
    }),
  ),
  totalCurrentCents: z.number().int(),
});
export type ReportBalancesResponse = z.infer<typeof reportBalancesResponseSchema>;
